import {option, Option} from "ts-option";
import {CreateQuoteEmailTemplateApiDto, QuoteEmailTemplateApiDto, UpdateQuoteEmailTemplateApiDto} from "../../api/model/rest";

const uuidv4 = require('uuid/v4');

export default class QuoteEmailTemplate {
	constructor(public readonly id: string,
		public readonly name: string,
		public readonly content: string) {}

	static fromJson(json: QuoteEmailTemplateApiDto): QuoteEmailTemplate {
		return new QuoteEmailTemplate(json.id, json.name, json.content)
	}

	static new(name: string, content: string) {
		const id = uuidv4();
		return new QuoteEmailTemplate(id, name, content)
	}

	toJson(): QuoteEmailTemplateApiDto {
		return {
			id: this.id,
			name: this.name,
			content: this.content
		}
	}

	toCreateJson(): CreateQuoteEmailTemplateApiDto {
		return {
			name: this.name,
			content: this.content
		}
	}

	toUpdateJson(): UpdateQuoteEmailTemplateApiDto {
		return {
			content: this.content
		}
	}

	copy({content = this.content}) {
		return new QuoteEmailTemplate(this.id, this.name, content)
	}
}
